import {CircularProgress,Box} from "@material-ui/core";

export default function Loader(){
    return (
        <Box className="text-center" mt={3}>
            <CircularProgress
                className="m-class"
                variant="indeterminate"
                size={50}
                thickness={3.6}
                color="primary"
            />
        </Box>
    )
}